import React from 'react';

const Value = ({ children }) => (
  <span className="value">{children}</span>
);

export default Value;
